export const getOpenDataTitle = (year: number, monthId?: number) => {
  let monthName = '';
  if (monthId === 1) {
    monthName = 'Январь';
  } else if (monthId === 2) {
    monthName = 'Февраль';
  } else if (monthId === 3) {
    monthName = 'Март';
  } else if (monthId === 4) {
    monthName = 'Апрель';
  } else if (monthId === 5) {
    monthName = 'Май';
  } else if (monthId === 6) {
    monthName = 'Июнь';
  } else if (monthId === 7) {
    monthName = 'Июль';
  } else if (monthId === 8) {
    monthName = 'Август';
  } else if (monthId === 9) {
    monthName = 'Сентябрь';
  } else if (monthId === 10) {
    monthName = 'Октябрь';
  } else if (monthId === 11) {
    monthName = 'Ноябрь';
  } else if (monthId === 12) {
    monthName = 'Декабрь';
  }

  if (monthName) {
    return `Проверки на ${monthName} ${year} года`;
  }
  return `Планы проверок на ${year} год`;
};
